/* src/app/components/layout/collapsed-timer/collapsed-timer.component.scss */
.collapsed-timer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 1.4rem;
  background-color: #ced7fd;
  padding: 1rem;
  box-shadow: 0 3px 6px 0 rgba(56, 51, 93, 0.31);
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  width: 18rem;
  max-width: 18rem;
}
.collapsed-timer--stopped {
  background-color: #e1e5f1;
}
.collapsed-timer__button {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}
.collapsed-timer__button__info:hover {
  opacity: 0.5;
}
.collapsed-timer__time-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.tooltip {
  overflow: visible;
  position: relative;
}
.tooltip:hover::before {
  display: block;
  content: attr(data-tooltip);
  background-color: #cdd1ef;
  overflow: visible;
  font-weight: normal;
  font-size: 1.3rem;
  color: #515258;
  font-style: normal;
  font-family: Rubik;
  letter-spacing: normal;
  font-stretch: normal;
  position: absolute;
  top: -5rem;
  border-width: 0.5rem;
  border-style: solid;
  border-radius: 0.3rem;
  border-color: #cdd1ef transparent transparent transparent;
}
.tooltip:hover::after {
  content: " ";
  position: absolute;
  top: -2.5rem;
  right: auto;
  left: 1rem;
  border-width: 0.5rem;
  border-style: solid;
  border-color: #cdd1ef transparent transparent transparent;
}
:host-context(body[dir=rtl]) .tooltip:hover::after {
  left: auto;
  right: 1rem;
}
/*# sourceMappingURL=collapsed-timer.component.css.map */
